if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let contentDOM = ``;
      let content = this.innerHTML;
    //console.log('Initial content:', content);
      let titleFlag = false;
      content = content.replace(/<\/p>|<\/div>/g, '');
      content = content.split('<p>');

      for (let i = 1; i < content.length; i++) {
        let contentArray = content[i].split(/<br>|<br\/>|\n/g);
      //console.log('Content array after split:', contentArray);
        
        // Clean and join content
        let cleanContent = contentArray.join('')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/\s+/g, ' ')
          .trim();
      //console.log('Cleaned content:', cleanContent);
        
        // Extract rows
        let tableRows = cleanContent.match(/<tr[^>]*>.*?<\/tr>/g) || [];
      //console.log('Table rows:', tableRows);

        // Parse serving size from header row: first row has <th>רכיב</th><th>400 גרם</th><th>100 גרם</th>
        let servingSizeFromTable = '';
        if (tableRows.length > 0) {
          const headerCells = tableRows[0].match(/<th[^>]*>(.*?)<\/th>/g);
          if (headerCells && headerCells.length >= 2) {
            servingSizeFromTable = headerCells[1].replace(/<\/?th[^>]*>/g, '').trim();
          }
        }
        
        contentDOM += `<div class="table">`;

        if (this.dataset.titleLabelLeft != '' || this.dataset.titleLabelRight != '' || this.dataset.titleLabelExtra != '') {
          if (!titleFlag) {
            titleFlag = true;
            // Build extra column label: "למנה (400 גרם)" when we have serving size from table
            let extraLabel = (this.dataset.titleLabelExtra || '').trim();
            if (extraLabel && servingSizeFromTable && servingSizeFromTable !== '100 גרם') {
              const baseLabel = extraLabel.replace(/\s*\([^)]*\)\s*$/, '').trim();
              if (baseLabel === 'למנה' || baseLabel.indexOf('למנה') === 0) {
                extraLabel = `למנה (${servingSizeFromTable})`;
              }
            }
            if (this.dataset.direction === 'rtl' && extraLabel) {
              extraLabel = extraLabel.replace(/\bg\b/g, 'גרם');
            }
          //console.log('Direction:', this.dataset.direction);
            contentDOM += `<span class="table-line table-line--heading" style="display: flex; justify-content: space-between; direction: ${this.dataset.direction === 'rtl' ? 'rtl' : 'ltr'};">`;
            if (this.dataset.direction === 'rtl') {
              if (this.dataset.titleLabelLeft != '') {
                contentDOM += `<span style="flex: 0 0 50%; text-align: right">${this.dataset.titleLabelLeft}</span>`;
              }
       
       
              if (this.dataset.titleLabelRight != '') {
                contentDOM += `<span style="flex: 0 0 25%; text-align: left">${this.dataset.titleLabelRight}</span>`;
              }
              if (extraLabel) {
                contentDOM += `<span style="flex: 0 0 25%; text-align: left">${extraLabel}</span>`;
              }
            } else {
              if (this.dataset.titleLabelLeft != '') {
                contentDOM += `<span style="flex: 0 0 50%; text-align: left">${this.dataset.titleLabelLeft}</span>`;
              }
              if (this.dataset.titleLabelRight != '') {
                contentDOM += `<span style="flex: 0 0 25%; text-align: right">${this.dataset.titleLabelRight}</span>`;
              }
              if (extraLabel) {
                contentDOM += `<span style="flex: 0 0 25%; text-align: right; margin-right: 10px;">${extraLabel}</span>`;
              }
            }
            contentDOM += `</span>`;
          }
        }

        // Process each row (skip header)
        for (let j = 1; j < tableRows.length; j++) {
        //console.log('Processing row:', tableRows[j]);
          
          // Extract all cells from the row
          let cells = tableRows[j].match(/<td[^>]*>(.*?)<\/td>/g) || [];
          let cellContents = cells.map(cell => 
            cell.replace(/<\/?td[^>]*>/g, '').trim()
          );
        //console.log('Row cells:', cellContents);

          if (cellContents.length > 0) {
            contentDOM += `<span class="table-line" style="display: flex; justify-content: space-between; direction: ${this.dataset.direction === 'rtl' ? 'rtl' : 'ltr'};">`;
            
            if (this.dataset.direction === 'rtl') {
              // Switch columns 2 and 3 by reordering array elements
              const reorderedCells = [
                cellContents[0],
                cellContents[2],
                cellContents[1]
              ];
              
              reorderedCells.forEach((content, index) => {
                const width = index === 0 ? '50%' : '25%';
                const align = index === 0 ? 'right' : 'left';
                contentDOM += `<span style="flex: 0 0 ${width}; text-align: ${align}">${content}</span>`;
              });
            } else {
              const reorderedCells = [
                cellContents[0],
                cellContents[2],
                cellContents[1]
              ];
              
              reorderedCells.forEach((content, index) => {
                const width = index === 0 ? '50%' : '25%';
                const align = index === 0 ? 'left' : 'right';
                contentDOM += `<span style="flex: 0 0 ${width}; text-align: ${align}">${content}</span>`;
              });
            }
            contentDOM += `</span>`;
          }
        }
        contentDOM += `</div>`;
      }
      
    //console.log('Final contentDOM:', contentDOM);
      this.innerHTML = contentDOM;
    }
  }

  if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
	}

}
